import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import Modal from "../global/modal";
import LoginForm from "./loginForm";
import Confirm from "../global/confirm";
import { getString } from "../../utilities";
import { isLoggedInSelector, loginModalSelector, modalToggle } from "../../redux/slices/loginSlice";
import { mpModalClicked, mpModalShown } from "../../utilities/mixpanel";
import { useLogout } from "../../hooks";
import OptionallyDisplayed from "../global/optionallyDisplayed";
import ErrorMessage from "../global/errorMessage";

export default function LoginModal() {
  const location = useLocation();
  const loginModal = useSelector(loginModalSelector);
  const isLoggedIn = useSelector(isLoggedInSelector);
  const dispatch = useDispatch();
  const { logout, submitErrors } = useLogout();

  const modalEventData = {
    modalType: "confirm-logout",
    triggerType: "button click",
    header: getString("navigation.logout.2"),
    primaryCta: getString("ok"),
    secondaryCta: "none",
    tertiaryCta: "none",
    isDismissible: true,
    pathname: location.pathname,
  };

  if (isLoggedIn) {
    if (loginModal) {
      mpModalShown(modalEventData);
    }
    return (
      <Modal doShow={loginModal} closeOnEscape={() => dispatch(modalToggle())}>
        <Confirm
          confirm={() => {
            mpModalClicked({
              ...modalEventData,
              interaction: "primary cta",
            });
            logout();
          }}
          cancel={() => {
            mpModalClicked({
              ...modalEventData,
              interaction: "dismissed",
            });
            dispatch(modalToggle());
          }}
        >
          <div className="modal-content-header">{getString("navigation.logout.2")}</div>
          <p>{getString("login.outConfirm")}</p>
          <OptionallyDisplayed doDisplay={!!submitErrors}>
            <ErrorMessage error={submitErrors} />
          </OptionallyDisplayed>
        </Confirm>
      </Modal>
    );
  }
  return (
    <Modal doShow={loginModal} closeOnEscape={() => dispatch(modalToggle())}>
      <LoginForm />
    </Modal>
  );
}
